import React from 'react';

import { useSelector } from 'react-redux';

import { EditOutlined } from '@ant-design/icons';

import { RibbonButton } from 'common/components';
import CreateEditAplModal from '../../sections/product-apl/components/CreateEditAplModal';

import { makeSelectAplDetail } from 'pages/product-apl-detail/controllers/selectors';

import { useGlobalModal } from 'hooks';
import { useCheckDisabledMasterAplBtn } from '../../sections/product-apl/hooks';

import { MASTER_APL_NAME } from '../../sections/product-apl/constants';
import Messages from 'i18n/messages/home';

const EditInfoMetadata = () => {
  const { openModal, MODAL_NAMES } = useGlobalModal();

  const aplDetail = useSelector(makeSelectAplDetail());

  const isDisabledMasterAplBtn = useCheckDisabledMasterAplBtn(aplDetail);

  const checkDisabled = () => {
    if (aplDetail?.aplName === MASTER_APL_NAME) return isDisabledMasterAplBtn;

    return !aplDetail?.isOwner;
  };

  const isDisabled = checkDisabled();

  return (
    <>
      <RibbonButton
        icon={<EditOutlined style={{ height: 26 }} />}
        label={Messages.editAplMetadata}
        onClick={() => openModal(MODAL_NAMES.EDIT_APL)}
        disabled={isDisabled}
      />

      <CreateEditAplModal aplId={aplDetail?.aplId} />
    </>
  );
};

export default EditInfoMetadata;
